// @flow

import { combineReducers } from "redux";

import * as atypes from "src/constants/actionTypes";
import type { SignUpError, Action } from "src/types";

const error = (state: SignUpError = {}, { type, payload }: Action) => {
  switch (type) {
    case atypes.JOIN_ORG_FAILURE:
      return {
        ...state,
        join: payload,
      };
    case atypes.JOIN_EXISTING_ORG_FAILURE:
      return {
        ...state,
        joinExistingOrg: payload
      };
    case atypes.SETUP_ORG_FAILURE:
      return {
        ...state,
        setupOrg: payload,
      };
    case atypes.CLEAR_SIGNUP_ERRORS:
      return {};
    default:
      return state;
  }
};

// Keep email as null for backward compatibility with selectors
const email = (state: ?string = null): ?string => null;

// Keep orgs as empty array for backward compatibility with selectors
const orgs = (state: Array<Object> = []): Array<Object> => [];

const joiningOrg = (state: boolean = false, { type }: Action) => {
  switch (type) {
    case atypes.JOIN_ORG_REQUEST:
      return true;
    case atypes.JOIN_ORG_FAILURE:
    case atypes.JOIN_ORG_SUCCESS:
      return false;
    default:
      return state;
  }
};

export default combineReducers<Object, Action>({
  error,
  email,
  orgs,
  joiningOrg,
});
